<template>
  <div class="confirm-dialog">
    <div class="mask">
      <div class="panel">
        <img
          v-if="showCloseBtn"
          class="img-close"
          @click="cancel"
          src="@/assets/img/icon-close.png"
          alt=""
        />
        <div class="title">
          <p>{{ title }}</p>
        </div>
        <div class="content">{{ content }}</div>
        <slot></slot>

        <slot name="btns">
          <div
            class="btns"
            :class="{ single: hideCancelBtn || hideConfirmBtn }"
          >
            <div v-if="!hideCancelBtn" class="btn cancel" @click="cancel">
              {{ cancelText }}
            </div>
            <div v-if="!hideConfirmBtn" class="btn submit" @click="submit">
              {{ confirmText }}
            </div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: function() {
        return '提示'
      }
    },
    content: {
      type: String,
      default: function() {
        return ''
      }
    },
    hideCancelBtn: {
      type: Boolean,
      default: false
    },
    hideConfirmBtn: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    showCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="less" scoped>
.confirm-dialog {
  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: 2000;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
    .panel {
      width: 310px;
      min-height: 80px;
      max-height: 80vh;
      border-radius: 5px !important;
      background: #fff;
      position: relative;
      transform: translate(-50%, -50%);
      left: 50%;
      top: 40%;
      z-index: 1;
      line-height: 1.4;
      padding-bottom: 80px;
      box-sizing: border-box;
      .img-close {
        display: block;
        width: 20px;
        height: 20px;
        position: absolute;
        right: 15px;
        top: 15px;
      }
      .title {
        font-size: 18px;
        font-weight: bold;
        padding-top: 20px;
        text-align: center;
        border: none;
        border-radius: 5px 5px 0 0;
        display: flex;
        align-items: center;
        p {
          flex: 1;
        }
      }
      .content {
        font-size: 14px;
        text-align: center;
        padding: 0 18px;
        padding-top: 15px;
        max-height: 40vh;
        overflow-y: scroll;
        box-sizing: border-box;
      }
      .fixed-value {
        font-size: 14px;
        line-height: 20px;
        text-align: left;
        padding: 0 25px;
        padding-top: 15px;
      }
      .btns {
        padding: 18px 27px 20px;
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        .btn {
          width: 110px;
          height: 36px;
          font-size: 14px;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          &.plain {
            color: #ecc381;
            background: #e8bc75;
            border: 1px solid #ecc381;
          }
        }
        .cancel {
          color: #999999;
          background: #f0f0f0;
        }
        .submit {
          color: #fff;
          background: #ecc381;
        }
        &.single {
          justify-content: center;
          .btn {
            width: 150px;
            height: 40px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
